import React, { useMemo } from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';

const PremiumMetric = ({ title, value }) => {
  const numericValue = parseFloat(value);
  const isPositive = numericValue >= 0;

  // High-contrast semantic colors used in professional financial UIs
  const color = isPositive ? '#137333' : '#D93025';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 'auto', pr: { xs: 2, sm: 3 } }}>
      <Typography
        variant="caption"
        sx={{
          color: '#5F6368',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          mb: 0.2,
          fontSize: '0.7rem'
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          color: color,
          fontSize: { xs: '1.1rem', sm: '1.25rem' },
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          letterSpacing: '-0.5px',
          lineHeight: 1
        }}
      >
        {isPositive ? '+' : ''}{numericValue.toFixed(2)}%
      </Typography>
    </Box>
  );
};

const PerformanceDisplay = ({ txtBlock, manager }) => {
  const perfData = useMemo(() => {
    if (!txtBlock) return [];

    try {
      const parsedTxtBlock = JSON.parse(txtBlock);
      const perfSection = parsedTxtBlock.find(section => section.section === "perfStr");

      if (perfSection && perfSection.text) {
        const parsedPerf = JSON.parse(perfSection.text);
        return parsedPerf.filter(p => p.perf !== "Inf");
      }
    } catch (error) {
      console.error("Error parsing performance data:", error);
    }

    return [];
  }, [txtBlock]);

  if (perfData.length === 0) return null;

  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: { xs: 'flex-start', md: 'flex-end' },
      alignItems: { xs: 'flex-start', md: 'center' },
      mt: { xs: 2, md: 0 },
      gap: { xs: 1, md: 3 },
    }}>
      <Typography
        variant="subtitle2"
        sx={{
          display: { xs: 'none', md: 'block' },
          color: '#202124',
          fontWeight: 600,
          fontSize: '0.9rem',
          maxWidth: '180px',
          lineHeight: 1.3,
          textAlign: 'right'
        }}
      >
        {manager} Performance
        {/* <Typography component="span" sx={{ display: 'block', color: '#80868B', fontSize: '0.75rem', fontWeight: 500 }}>
          Performance
        </Typography> */}
      </Typography>

      <Stack
        direction="row"
        alignItems="center"
        divider={<Divider orientation="vertical" flexItem sx={{ borderColor: '#DADBDF', my: 0.5, mr: { xs: 2, sm: 3 } }} />}
        sx={{ overflow: 'hidden', }}
      >
        {perfData.map(({ year, perf }) => (
          <PremiumMetric key={year} title={year} value={perf} />
        ))}
      </Stack>
    </Box>
  );
};

export default PerformanceDisplay;